<script lang="ts">
    import { onMount } from "svelte";
	import { navigate } from "svelte-navigator";

    import { StorageKeys } from "./enums/localStorageKeys";
    import { accessToken, errorMessage } from "./store";

    let tenantName = localStorage.getItem(StorageKeys.TenantName);
    let userName = localStorage.getItem(StorageKeys.UserName);
    let password = localStorage.getItem(StorageKeys.Password);
    let expireInSeconds = Math.round(3600 / 2);

    function onSubmit(e) {
        const formData = new FormData(e.target);
        const data = {};
        for (let field of formData) {
            const [key, value] = field;
            if (!value) continue;
            data[key] = String(value).trim();
        }
        localStorage.setItem(StorageKeys.TenantName, data["tenantName"]);
        localStorage.setItem(StorageKeys.UserName, data["userName"]);
        localStorage.setItem(StorageKeys.Password, data["password"]);
        authenticate(data);
    }

    function authenticate(data) {
        fetch(`FX_HOST_SAND/api/identity/v1/TokenAuth/Authenticate`, {
            method: "post",
            headers: new Headers([["Content-Type", "application/json"]]),
            body: JSON.stringify({ ...data, expireInSeconds }),
        })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    errorMessage.set(res.statusText ?? 'Error occurred')
                }
            })
            .then((res) => {
                if(!res) return;
                localStorage.setItem(StorageKeys.AccessToken, res.accessToken);
                accessToken.set(res.accessToken);
                let expirationDate = Date.now() + expireInSeconds * 1000;
                localStorage.setItem(
                    StorageKeys.AccessTokenExpirationDate,
                    String(expirationDate)
                );
                navigate("/cart", { replace: true });
            });
    }
</script>

<div class="flex justify-center items-start pt-16 w-full h-full">
    <div class="w-80 px-4 py-2 shadow-xl rounded-xl border border-gray-100">
        <h1 class="font-bold pb-4 text-3xl">Login</h1>
        <form
            on:submit|preventDefault={onSubmit}
            class="flex flex-col gap-2 w-full"
        >
            <div>
                <label
                    for="tenantName"
                    class="block text-sm font-medium text-gray-700"
                    >Tenant Name</label
                >
                <input
                    id="tenantName"
                    name="tenantName"
                    required
                    bind:value={tenantName}
                    type="text"
                    class="mt-1 text-xs p-2 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm border border-gray-300 rounded-md"
                />
            </div>
            <div>
                <label
                    for="userName"
                    class="block text-sm font-medium text-gray-700"
                    >User Name</label
                >
                <input
                    id="userName"
                    name="userName"
                    required
                    bind:value={userName}
                    type="text"
                    class="mt-1 text-xs p-2 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm border border-gray-300 rounded-md"
                />
            </div>
            <div>
                <label
                    for="password"
                    class="block text-sm font-medium text-gray-700"
                    >Password</label
                >
                <input
                    id="password"
                    name="password"
                    required
                    bind:value={password}
                    type="password"
                    class="mt-1 text-xs p-2 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm border border-gray-300 rounded-md"
                />
            </div>
            <div class="py-2">
                <button
                    class="bg-indigo-500 p-2 rounded-lg text-white flex-grow w-full"
                    type="submit"
                >
                    Save
                </button>
            </div>
        </form>
    </div>
</div>
